import { render } from "./PreviewPopup.vue?vue&type=template&id=22f0937e&scoped=true"
import script from "./PreviewPopup.vue?vue&type=script&lang=ts"
export * from "./PreviewPopup.vue?vue&type=script&lang=ts"

import "./PreviewPopup.vue?vue&type=style&index=0&id=22f0937e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22f0937e"

export default script
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtnToggle,QBtn});
